module.exports = __webpack_public_path__ + "img/noneimg.150b9461.jpg";